// extracted by mini-css-extract-plugin
export default {"backButton":"NavigationHeader_backButton__K5d51"};